// extracted by mini-css-extract-plugin
export var compare__single = "styles-module--compare__single--ee777";
export var compare__table = "styles-module--compare__table--6f1e0";
export var first__col = "styles-module--first__col--a6c3e";
export var main__img = "styles-module--main__img--bf569";
export var more__btn = "styles-module--more__btn--f70e4";
export var product__name = "styles-module--product__name--ed88a";
export var show__more = "styles-module--show__more--052dc";
export var sticky__col = "styles-module--sticky__col--37e8a";
export var table = "styles-module--table--baa04";
export var title = "styles-module--title--6322c";